/**
 * The sidebar rows, transcribed from `design/PortalDashboard.dc.html`.
 *
 * Nine keys, in the order the artboard draws them. That order is the
 * information architecture of the portal and it is not ours to re-sort. Each
 * key is also the row's URL segment, see `src/routes.ts`.
 *
 * This lives apart from `NavIcon.tsx` so that file exports only a component,
 * which is what React fast refresh needs.
 */

/** The label each key is drawn with, verbatim. Copy is design too. */
export const navLabels: Record<string, string> = {
  dashboard: 'Dashboard',
  products: 'Products',
  'code-batches': 'Code batches',
  reports: 'Reports',
  'consumer-reports': 'Consumer reports',
  alerts: 'Alerts',
  team: 'Team',
  'api-keys': 'API keys',
  'brand-profile': 'Brand profile',
};

export type NavKey = keyof typeof navLabels;
